<template>
    <v-card class="rounded-xl elevation-3" flat>
        <create-dialog></create-dialog>
        
        <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
            Lịch sử cập nhật thông tin
            <v-spacer></v-spacer>
            
            <div class="d-flex align-center wrapper mx-1 my-1">
                <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="green darken-4">mdi-refresh</v-icon>
                </v-btn>
            </div>
            
            <v-divider vertical class="mx-4"></v-divider>
            
            <v-btn color="teal darken-4" dark @click="openDialog" class="rounded-pill elevation-3 font-weight-bold px-6"> 
                <v-icon left>mdi-plus</v-icon> TẠO PHIẾU
            </v-btn>
        </v-card-title>

        <v-sheet class="grey lighten-4 py-4 px-6 mb-2" style="border-top: 1px solid #eee;">
            <div class="d-flex flex-wrap align-center">
                <v-text-field 
                    outlined 
                    hide-details 
                    v-model="search" 
                    label="Tìm kiếm nhanh..." 
                    dense 
                    prepend-inner-icon="mdi-magnify"
                    style="max-width: 300px; background-color: white;" 
                    class="rounded-lg mr-4"
                ></v-text-field>
            </div>
        </v-sheet>

        <v-data-table 
            class="my-custom-table"
            :mobile-breakpoint="0"
            height="600px" fixed-header
            :headers="headers"
            :items="items"
            :loading="isLoading"
            :search="search"
            loading-text="Đang tải dữ liệu..."
            :footer-props="{
                itemsPerPageOptions:[ 50, 100, 200 ]
            }"
        >
            <template v-slot:[`item.id`]="{item}">
                <a @click="editItem(item)" class="font-weight-bold grey--text text--darken-3">{{ item.id }}</a>
            </template>

            <template v-slot:[`item.employee`]="{item}">
                <div class="d-flex align-center py-2">
                    <v-avatar size="36" class="elevation-1 grey lighten-3">
                        <v-img :src="item.avatar" alt="">
                            <template v-slot:placeholder>
                                <v-icon small>mdi-account</v-icon>
                            </template>
                        </v-img>
                    </v-avatar>
                    <div class="ml-3">
                        <div class="font-weight-bold grey--text text--darken-3" style="line-height: 1.2;">{{ item.employeeName || 'Không có dữ liệu' }}</div>
                        <div class="caption grey--text">{{ item.employeeCode || 'Không có dữ liệu' }}</div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.createdAt`]="{item}">
                <div class="caption font-weight-medium grey--text text--darken-2">
                    <v-icon x-small color="grey lighten-1">mdi-clock-outline</v-icon>
                    {{$formatter.formatDate(item.createdAt, 'DD/MM/YYYY HH:mm:ss')}}
                </div>
            </template>

            <template v-slot:[`item.status`]="{item}">
                <v-chip :color="getStatusColor(item.status)" dark small label class="font-weight-bold elevation-1">
                    {{ getStatusText(item.status) }}
                </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex align-center">
                    <v-btn x-small depressed rounded color="blue lighten-5" @click="editItem(item)" class="mx-1 font-weight-bold blue--text text--darken-3">
                        <v-icon left small>mdi-eye</v-icon> Xem
                    </v-btn>
                    <v-btn v-if="item.status == 0" x-small depressed rounded color="red lighten-5" @click="deleteItem(item)" class="mx-1 font-weight-bold red--text text--darken-3">
                        <v-icon left small>mdi-delete</v-icon> Xóa
                    </v-btn>
                </div>
            </template>
        </v-data-table>

        <!-- Delete Confirmation Dialog -->
        <v-dialog v-model="dialogDelete" max-width="480px">
            <v-card class="rounded-xl">
                <v-card-title class="headline font-weight-bold grey--text text--darken-3 px-6 pt-6">
                    Xác nhận xóa phiếu
                </v-card-title>
                <v-card-text class="px-6 grey--text text--darken-1">
                    Bạn có chắc chắn muốn xoá phiếu này? Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text class="font-weight-bold" @click="dialogDelete=false">Thoát</v-btn>
                    <v-btn color="red darken-2" dark class="font-weight-bold rounded-lg px-6 elevation-2" @click="cfmDeleteItem">Xóa phiếu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import CreateButton from '@/components/Crud/CreateButton'
import http from '@/components/services/http-common'
import InfoUpdateApi from './api.js'
import * as moment from "moment/moment";
import ApiServices from '@/components/services/ApiServices.js';
import Create from './Create'

export default {
    name: 'InfoUpdateIndex',
    components: {
        CreateButton,
        'create-dialog': Create
    },
    props:["breadcrumbs", "icon"],
    data () {
        return {
            // URLS
            ROOT_URL: "jobs",

            rootUrl: "positions",

            //dialog
            // dialog: {state: false, item: undefined},
            
            //datatable config
            totalItem: 0,
            items: [],
            search:"",
            options: {},
            isLoading: true,
            dialogDelete: false,
            targetItem: undefined,
            employee: null,
            dialog:false,
            isValid: false,
            base64: '',

            headers: [
                { text: 'Thao tác', align: 'center', sortable: false, value: 'actions', width: '120px' },
                { text: 'ID', align: 'start', sortable: true, value: 'id', width: '80px' },
                { text: 'Nhân viên', value: 'employee', width: '220px' },
                { text: 'Ngày tạo', value: 'createdAt', width: '180px' },
                { text: 'Trạng thái', value: 'status', width: '140px' },
            ],
        }
    },
    watch: {
      options: {
        handler (val) {
            this.fetchData();
        },
        deep: true,
      },
    //   dialog:{
    //     handler(val) {
    //       if(val) {
    //       this.openDialog()
    //       } else {
    //         this.closeHandler()
    //       }
    //     }
    //   },
      search:{
          handler() {
            this.options.page = 1;
          }
      },
    },
    methods:{
        openDialog(){
            this.$root.$emit('openDialog')
            // this.getEmployee()
        },
        fetchData () {
            this.isLoading = true;
            return InfoUpdateApi.gets().then(d => {
                this.items = d
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        editItem(item) {
            this.$root.$emit('editDialog', item)
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            return  InfoUpdateApi.remove(this.targetItem.id).then(() => {
                this.dialogDelete = false;
                this.fetchData()
            })
        },

        changeVisible(item){
            return http.get('jobs/visibility/'+item.code, {
                params: {
                    status: item.isActive
                }
            }).then(() => {
                return this.fetchData()
            })
        },
        closeHandler() {
            // this.dialog = {state: false, item: undefined}
        },

        
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        getStatusColor(status) {
            switch(status) {
                case 0: return 'blue darken-2';
                case 1: return 'green darken-2';
                case 2: return 'red darken-2';
                default: return 'grey';
            }
        },
        getStatusText(status) {
            switch(status) {
                case 0: return 'Chờ duyệt';
                case 1: return 'Đã duyệt';
                case 2: return 'Từ chối';
                default: return 'Không xác định';
            }
        }
    },


    mounted () {
        this.fetchData()
        // this.fetchOrigin()
        // this.fetchCity()
        // this.fetchBank()
        // ApiServices.fetchReligion().then(r => {
        //     this.religions = r.data
        // })
        // ApiServices.fetchEthnicity().then(r => {
        //     this.ethnicities = r.data
        // })
    },
    created()
    {
        this.$emit("setUrl", this.breadcrumbs);
    }, 
    destroyed() {
        this.$emit("setUrl", []);
    }
}
</script>

<style scoped>
/* Use ::v-deep or >>> to target the inner <thead> */
.my-custom-table ::v-deep thead th {
  background-color: #F8F9FA !important; 
  height: 48px !important;
}

.my-custom-table ::v-deep thead th span {
  font-weight: 600 !important;
  color: #37474F !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.my-custom-table ::v-deep tbody tr:hover {
    background-color: #F1F8E9 !important;
}
</style>